<template>
    <div v-if="revenues" class="sub-total">
        <span class="alt">Jouw omzet (70%)</span>
        <span>&euro; {{ formatCurrency(revenues) }}</span>
    </div>
</template>
<script>
import RockCurrencyMixin from '@/mixins/RockCurrencyMixin.js';

export default {
    mixins: [RockCurrencyMixin],
    props: ['revenues']
};
</script>
